/** A URL parameter that only development builds read (?scenario=, ?now=). */
export function devParam(name: string): string | null {
  if (!import.meta.env.DEV || typeof location === 'undefined') return null
  return new URLSearchParams(location.search).get(name)
}
